module.exports = __webpack_public_path__ + "img/kehufuwu.98d3fb25.png";